import React from 'react'
import { SvgIcon } from '@material-ui/core'

export default function NmkIcon() {
  return (
    <SvgIcon>
      <svg
        version="1.0"
        xmlns="http://www.w3.org/2000/svg"
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        preserveAspectRatio="xMidYMid meet"
      >
<g>
	<path class="st0" d="M12.7,16.29c1.18,1.18,2.35,2.34,3.5,3.48c1.16-1.16,2.33-2.32,3.5-3.49c-1.16-1.16-2.33-2.33-3.49-3.48
		C15.04,13.97,13.87,15.14,12.7,16.29z M4.32,16.29c1.18,1.17,2.36,2.34,3.5,3.49c1.16-1.15,2.33-2.32,3.5-3.48
		c-1.16-1.16-2.34-2.33-3.5-3.49C6.66,13.97,5.49,15.13,4.32,16.29z M4.32,7.78c1.18,1.17,2.35,2.33,3.5,3.48
		c1.16-1.16,2.33-2.33,3.5-3.49c-1.16-1.16-2.33-2.33-3.49-3.48C6.67,5.45,5.5,6.61,4.32,7.78z M16.2,4.3
		c-1.16,1.16-2.33,2.32-3.5,3.48c1.16,1.16,2.34,2.33,3.5,3.48c1.16-1.16,2.33-2.32,3.5-3.48C18.53,6.62,17.36,5.45,16.2,4.3z
		 M7.19,12.03c-1.16-1.16-2.33-2.32-3.48-3.47c0,2.3,0,4.63,0,6.92C4.86,14.33,6.03,13.18,7.19,12.03z M16.84,12.02
		c1.16,1.16,2.33,2.31,3.48,3.46c0-2.3,0-4.62,0-6.93C19.16,9.71,18,10.87,16.84,12.02z M11.95,8.55C10.79,9.7,9.63,10.86,8.48,12
		c2.28,0,4.6,0,6.91,0C14.24,10.84,13.07,9.68,11.95,8.55z"/>
	<path d="M12.7,16.29c1.16-1.16,2.34-2.33,3.51-3.49c1.16,1.16,2.33,2.32,3.49,3.48c-1.17,1.17-2.35,2.33-3.5,3.49
		C15.05,18.63,13.87,17.47,12.7,16.29z"/>
	<path d="M4.32,16.29c1.16-1.16,2.33-2.33,3.5-3.49c1.16,1.16,2.34,2.33,3.5,3.49c-1.17,1.16-2.34,2.33-3.5,3.48
		C6.68,18.63,5.5,17.46,4.32,16.29z"/>
	<path d="M4.32,7.78C5.5,6.61,6.67,5.45,7.83,4.29C9,5.45,10.16,6.62,11.32,7.77c-1.17,1.16-2.34,2.33-3.5,3.48
		C6.67,10.12,5.5,8.95,4.32,7.78z"/>
	<path d="M16.2,4.3c1.16,1.15,2.33,2.32,3.5,3.49c-1.17,1.16-2.34,2.33-3.5,3.48c-1.16-1.16-2.33-2.33-3.5-3.48
		C13.87,6.63,15.04,5.45,16.2,4.3z"/>
	<path d="M7.19,12.03c-1.16,1.15-2.32,2.3-3.48,3.45c0-2.3,0-4.62,0-6.92C4.86,9.71,6.02,10.87,7.19,12.03z"/>
	<path d="M16.84,12.02c1.16-1.16,2.33-2.32,3.48-3.47c0,2.3,0,4.63,0,6.93C19.16,14.33,17.99,13.18,16.84,12.02z"/>
	<path d="M11.95,8.55c1.13,1.13,2.29,2.28,3.45,3.45c-2.31,0-4.63,0-6.91,0C9.63,10.86,10.79,9.7,11.95,8.55z"/>
</g>    </svg>
    </SvgIcon>
  )
}
